import cls from 'classnames';
import { faPerson } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { buildEmployeeSet, EmployeeIndicatorLegend, hasEmployeeInLookup } from './common';

export const getEmployeeStatusIndicators = (empId, mapData) => {
    if (!mapData || empId == null) {
        return [];
    }

    const indicators = [];

    if (hasEmployeeInLookup(mapData.employeesByDailyAttendanceEvent, empId)) {
        indicators.push(EmployeeIndicatorLegend.find((item) => item.key === 'daily-attendance-event'));
    }

    if (hasEmployeeInLookup(mapData.employeesByJobAssignmentCancellation, empId)) {
        indicators.push(EmployeeIndicatorLegend.find((item) => item.key === 'job-cancellation'));
    }

    if (hasEmployeeInLookup(mapData.employeesByLongTermStatus, empId)) {
        indicators.push(EmployeeIndicatorLegend.find((item) => item.key === 'long-term-status'));
    }

    const notConfirmedSet = buildEmployeeSet(mapData.notConfirmed);
    if (notConfirmedSet.has(empId)) {
        indicators.push(EmployeeIndicatorLegend.find((item) => item.key === 'not-confirmed'));
    }

    const notScheduledSet = buildEmployeeSet(mapData.notScheduled);
    if (notScheduledSet.has(empId)) {
        indicators.push(EmployeeIndicatorLegend.find((item) => item.key === 'not-scheduled'));
    }

    const onCallEmp = (mapData.employees || []).find((e) => (e.id ?? e.employeeId) === empId);
    if (onCallEmp?.isFlaggerAvailableForOnCall === true) {
        indicators.push(EmployeeIndicatorLegend.find((item) => item.key === 'on-call'));
    }

    const confirmedSet = buildEmployeeSet(mapData.confirmed);
    if (confirmedSet.has(empId)) {
        indicators.push(EmployeeIndicatorLegend.find((item) => item.key === 'confirmed'));
    }

    return indicators;
};

export const EmployeeMarkerIcon = ({ selected, isHighlighted, indicators }) => (
    <div style={{ position: 'relative', display: 'inline-block' }}>
        <FontAwesomeIcon
            icon={faPerson}
            size="2x"
            className={cls('map-marker', isHighlighted ? 'text-danger' : 'text-primary', selected && 'map-marker-selected')}
        />

        {indicators.length > 0 && (
            <div className="employee-marker-indicator">
                {indicators.map((indicator, idx) => (
                    <FontAwesomeIcon
                        key={idx}
                        icon={indicator.icon}
                        style={{ color: indicator.color, fontSize: 10 }}
                        title={indicator.title}
                    />
                ))}
            </div>
        )}
    </div>
);